export const clientTypeOptions: string[] = ['Geotab Reseller', 'New Geotab Customer', 'Existing Geotab Customer'];
